import React from "react";
import UseData from "../Hooks/UseData";

const SliderCommon = () => {
  const { sliderBadges } = UseData();
  // console.log(sliderBadges)

  return (
    <div className="bg-[#F8FBFB] dark:bg-[#0D0D0D] max-w-full h-auto   py-10 rounded-xl">
      <h3 className="badge text-center dark:text-white text-6xl mb-3 font-semibold ">
        Badges
      </h3>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "0 10px",
          overflowX: "auto",
        }}
      >
        {sliderBadges.map((item, i) => (
          <div
            key={i}
            style={{ minWidth: "150px" }} // Set a minimum width for each badge
            data-iframe-width="150"
            data-iframe-height="270"
            data-share-badge-id={item.id}
            data-share-badge-host="https://www.credly.com"
          />
        ))}
      </div>
    </div>
  );
};

export default SliderCommon;
